// Generated by Melange

import LabelModuleCss from "./label.module.css";
import * as Caml_option from "melange.js/caml_option.jsx";
import Clsx from "clsx";
import * as JsxRuntime from "react/jsx-runtime";

const css = LabelModuleCss;

function Label(Props) {
  let children = Props.children;
  let className = Props.className;
  let htmlFor = Props.htmlFor;
  let id = Props.id;
  let tmp = {
    className: Clsx(className, css.root)
  };
  if (children !== undefined) {
    tmp.children = Caml_option.valFromOption(children);
  }
  if (id !== undefined) {
    tmp.id = Caml_option.valFromOption(id);
  }
  if (htmlFor !== undefined) {
    tmp.htmlFor = Caml_option.valFromOption(htmlFor);
  }
  return JsxRuntime.jsx("label", tmp);
}

const make = Label;

export {
  make,
}
/* css Not a pure module */
